/* eslint-disable prettier/prettier */
export default {
  dbh_dashboard_giudebox_title: '经分介绍',
  dbh_dashboard_giudebox_desc: '全面掌握游戏经营数据，智能分析游戏表现。关于经分模块的介绍显示在这里。',
  dbh_dashboard_giudebox_block_title: '新手引导-核心功能展示',
  dbh_dashboard_giudebox_list1_title: '查看游戏运营总况数据',
  dbh_dashboard_giudebox_list1_desc: '一页总览游戏运营核心指标数据',
  dbh_dashboard_giudebox_list2_title: '监控全球实时数据',
  dbh_dashboard_giudebox_list2_desc: '快速发现各国实时指标异动',
  dbh_dashboard_giudebox_list3_title: '查看全球多时区数据',
  dbh_dashboard_giudebox_list3_desc: '获取当地数据，分国家进行数据对比',
  dbh_dashboard_giudebox_list4_title: '查看游戏定制化特性报表',
  dbh_dashboard_giudebox_list4_desc: '查看游戏玩法/活动等游戏内特性分析数据',
  dbh_dashboard_giudebox_list5_title: '报表订阅推送',
  dbh_dashboard_giudebox_list5_desc: '及时地获取最新信息，自动化推送日报周报/月报',
};
